var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PostAiInterviewEvaluation } from "../../../../services/ai-report";
import { Button, confirm, EditIcon, FormItem, IconButton, Typography } from 'fbm-ui';
import { Box, Stack } from 'fbm-ui/lib/mui';
import { useCallback, useEffect, useState } from 'react';
var Evaluate = function (_a) {
    var title = _a.title, evaluations = _a.evaluations, token = _a.token, field = _a.field, _b = _a.mode, mode = _b === void 0 ? 'show' : _b, _c = _a.canEdit, canEdit = _c === void 0 ? 'false' : _c;
    var _d = __read(useState(evaluations), 2), content = _d[0], setContent = _d[1];
    var _e = __read(useState('show'), 2), internalMode = _e[0], setInternalMode = _e[1];
    var handleChange = useCallback(function (e) {
        var value = e.target.value;
        setContent(value);
    }, []);
    var handleModeChange = useCallback(function () {
        setInternalMode(internalMode === 'show' ? 'edit' : 'show');
    }, [internalMode]);
    var handleSubmit = useCallback(function () {
        confirm({
            header: null,
            content: '确认将评价内容修改吗？该动作无法被撤销。',
            okText: '修改',
            okProps: {
                color: 'error',
                variant: 'contained',
            },
            onOk: function (_a) {
                var onClose = _a.onClose;
                var data = field === 'evaluations'
                    ? {
                        evaluationToken: token,
                        manualEvaluations: [content],
                    }
                    : {
                        evaluationToken: token,
                        manualSuggestions: [content],
                    };
                PostAiInterviewEvaluation(data).then(handleModeChange).then(onClose).catch(console.log);
            },
        });
    }, [token, content, field, handleModeChange]);
    useEffect(function () {
        setInternalMode(mode);
    }, [mode]);
    return (_jsxs(Stack, __assign({ sx: {
            mt: 3,
            background: '#FFFBE8',
            boxShadow: ' 0px 2px 6px 0px rgba(91,108,95,0.15)',
            padding: '8px 24px',
            borderRadius: 1.5,
        } }, { children: [_jsxs(Stack, __assign({ direction: "row", alignItems: "center", justifyContent: "space-between", height: 36, mb: 1 }, { children: [_jsx(Box, __assign({ sx: {
                            position: 'relative',
                            '&:after': {
                                position: 'absolute',
                                width: 'calc(100% - 2px)',
                                background: ' linear-gradient( 90deg, #FFE5A9 0%, #FFB300 100%)',
                                left: -3,
                                bottom: 2,
                                height: 5,
                                content: '""',
                                color: 'rgba(0, 0, 0, 0.54)',
                                display: 'inline-block',
                                margin: '0 4px',
                            },
                        } }, { children: _jsx(Typography, __assign({ fontWeight: "medium", zIndex: 1, sx: { position: 'relative', zIndex: 1 } }, { children: title })) })), canEdit && (_jsx(IconButton, __assign({ onClick: handleModeChange }, { children: _jsx(EditIcon, {}) })))] })), internalMode === 'edit' && (_jsxs(Box, __assign({ width: 1, pr: 2 }, { children: [_jsx(FormItem, { sx: { height: 'auto', pr: 0 }, multiline: true, rows: 3.5, required: true, name: "name", placeholder: "", value: content, onChange: handleChange }), _jsxs(Stack, __assign({ boxSizing: "border-box", mr: 2, mt: 1, spacing: 1, direction: "row", width: 1, justifyContent: "flex-end" }, { children: [_jsx(Button, __assign({ size: "medium", variant: "text", color: "secondary", onClick: function () {
                                    handleModeChange();
                                    // setContent(evaluations?.join('\n'));
                                } }, { children: "\u53D6\u6D88" })), _jsx(Button, __assign({ size: "medium", onClick: handleSubmit }, { children: "\u4FDD\u5B58" }))] }))] }))), internalMode === 'show' && (_jsx(Typography, __assign({ variant: "body2", color: "textSecondary", sx: { whiteSpace: 'pre-wrap' } }, { children: content })))] })));
};
export default Evaluate;
